import { render, staticRenderFns } from "./security-center.vue?vue&type=template&id=d2a29b84&scoped=true"
import script from "./security-center.vue?vue&type=script&lang=js"
export * from "./security-center.vue?vue&type=script&lang=js"
import style0 from "./security-center.vue?vue&type=style&index=0&id=d2a29b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a29b84",
  null
  
)

export default component.exports